// Define status colors for visual representation
  const getStatusColor = (status) => {
    switch (status) {
      case "UNDER_REVIEW":
        return "warning";
      case "PLAN_ESTABLISHED":
        return "info";
      case "WAITING_FOR_SUPPORT_OF_MARKETING":
        return "primary";
      case "WAITING_FOR_SUPPORT_OF_SUPPLY_CHAIN":
        return "primary";
      case "WAITING_FOR_SUPPORT_OF_BOTH_DEPARTMENTS":
        return "primary";
      case "COMPLETED":
        return "success";
      default:
        return "default";
    }
  };

  // Get color for restriction type
  const getRestrictionTypeColor = (type) => {
    switch (type) {
      case "BANNED":
        return "error";
      case "RESTRICTED":
      case "LABELING_REQUIREMENTS":
      case "RESTRICTIONS_AND_LABELING":
      case "RESTRICTED_AND_SDS":
        return "warning"; // All non-banned restrictions use the same warning color
      default:
        return "default";
    }
  };

  // Centralized color mapping for restriction types to ensure consistency across the system
  const getRestrictionTypeColorStyles = (type) => {
    const colorType = getRestrictionTypeColor(type);

    switch (colorType) {
      case "error": // BANNED
        return {
          backgroundColor: "#FFCDD2",
          color: "#D32F2F",
          border: "1px solid #EF9A9A"
        };
      case "warning": // RESTRICTED, LABELING_REQUIREMENTS, RESTRICTIONS_AND_LABELING
        return {
          backgroundColor: "#FFECB3",
          color: "#F57C00",
          border: "1px solid #FFD54F"
        };
      default:
        return {
          backgroundColor: "#EEEEEE",
          color: "#757575",
          border: "1px solid #E0E0E0"
        };
    }
  };

  export {getStatusColor, getRestrictionTypeColor, getRestrictionTypeColorStyles}
